import React from "react";

const ResearchNews = () => {
  return (
    <div>
      <h1>ResearchNews</h1>
      <p>Welcome to the Research & News page!</p>
    </div>
  );
};

export default ResearchNews;